const forms = {
  defaultForm: {
    structure: {
      title: 'Hello Form!',
      fields: {
        email: { type: 'email', label: 'Email' },
        password: { type: 'password', label: 'Password' },
        submit: { type: 'submit', label: '&nbsp;', attributes: { value: 'Login' } },
      },
      layout: [
        ['email', 'password', 'submit']
      ]
    }
  },
  materialDesign: {
    structure: {
      title: 'Style like Google Material Design',
      fields: {
        email: { type: 'email', label: 'Email' },
        password: { type: 'password', label: 'Password' },
        submit: { type: 'submit', label: '&nbsp;', attributes: { value: 'Login' } },
      },
      layout: [
        ['email', 'password', 'submit']
      ]
    }
  },
  signUp: {
    structure: {
      title: 'Signup form #1',
      fields: { 
        firstname: { type: 'text', label: 'First name' }, 
        lastname: { type: 'text', label: 'Last name' }, 
        email: { type: 'email', label: 'Email / username' },  
        password: {type: 'password', label: 'Password' },
        confirm: {type: 'password', label: 'Confirm password' },
        privacy: { type: 'checkbox', label: 'Accept privacy policy. [Read it here](https://beefree.io/pro/privacy.html)', attributes: { required: true} },
        submit: { type: 'submit', attributes: { value: 'Sign up' } } 
      },
      layout: [
        [ 'firstname', 'lastname'],
        [ 'email' ],
        [ 'password', 'confirm'],
        [ 'privacy'],
        [ 'submit' ]
      ]
    }
  },
  login: {
    structure: {
      title: 'Login form #1',
      fields: { 
        email: { type: 'email', label: 'E-mail' }, 
        password: {type: 'password', label: 'Password' }, 
        remember: { type: 'checkbox', label: 'Remember me' },
        
        submit: { type: 'submit', attributes: { value: 'Login' } },
      },
      layout: [[ 'email'], ['password'], ['remember'], [ 'submit' ]]
    }
  },
  passwordRecovery: {
    structure: {
      title: 'Password recovery',
      fields: { 
        intro: { type: 'label', label: 'Enter your username or email address to receive a link to reset your password.' },
        email: { type: 'email', attributes:{ placeholder: 'Username / email' } },
        submit: { type: 'submit', attributes: { value: 'Reset my password' } }
      },
      layout: [['intro'],[ 'email'],[ 'submit' ]]
    }
  },
  bookAppointment: {
    structure: {
      fields: {
        name: {type: 'text', label: 'Name', removeFromLayout: false, canBeRemovedFromLayout: true},
        surname: {type: 'text', label: 'Surname *', removeFromLayout: false, canBeRemovedFromLayout: true, attributes: { required: true,}},
        date: { type: 'datetime-local', label: 'Pick the date/time *', removeFromLayout: false, canBeRemovedFromLayout: true, attributes: { required: true}},
        model: {
          type: 'select',
          label: 'Pick the model you wish to test *',
          removeFromLayout: false,
          canBeRemovedFromLayout: true,
          options: [{type:'option', label:'Please choose', value:''},{type:'option', label:'S8', value:'normal'}, {type:'option', label:'S8 Plus', value:'plus'}],
          attributes: {required: true}
        },
        submit:{type:'submit',label:'',removeFromLayout:false,canBeRemovedFromLayout:true,attributes:{value:'Book your test drive',class:'submitButton',name:'submit'}}
      },
      layout: [['name'],['surname'],['date'],['model'],['submit']],
      attributes: {
        'accept-charset': 'UTF-8',
        action: 'http://matteosantagata.com/beeforms/read-form',
        autocomplete: 'on',
        enctype: 'multipart/form-data',
        method: 'post',
        novalidate: false,
        target: '_self'
      },
      title: 'Test drive booking',
      description: 'A BEE test form'
    }    
  }
}

export default forms
